import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import type { ActiveForm } from 'modules/forms/types';

type ActiveFormState = { current: ActiveForm | null };

const initialState: ActiveFormState = { current: null };

export const activeFormSlice = createSlice({
  name: 'activeForm',
  initialState,
  reducers: {
    // One form at a time: a second request never replaces a form the person is filling in.
    formRequested: (state, action: PayloadAction<ActiveForm>) => {
      state.current ??= action.payload;
    },
    formClosed: (state) => {
      state.current = null;
    },
  },
});

export const { formRequested, formClosed } = activeFormSlice.actions;
